import { useMemo } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import { useAccessToken } from 'src/hooks/useAccessToken';
import { CustomQueryOptions, FetchError } from 'src/types/TApiQueries';
import { OnboardingProgress } from 'src/types/TOnboarding';
import { getOnboardingProgress } from '../functions/onboardingApi';
import { queryFnFetchErrorWrapper, throwFetchError } from '../utils/errorHandlers';
import { mergeQueryOptions } from '../utils/helpers';
import { queryNames } from '../utils/queryNames';

export function useOnboardingProgressQuery(
  options?: CustomQueryOptions,
  queryOptions?: UseQueryOptions<OnboardingProgress, FetchError>,
) {
  const actualQueryOptions = mergeQueryOptions(options, queryOptions);
  const accessToken = useAccessToken();

  const queryFn = useMemo(
    () => queryFnFetchErrorWrapper(() => getOnboardingProgress(accessToken)),
    [accessToken],
  );

  const query = useQuery<OnboardingProgress, FetchError>(
    [queryNames.onboardingProgress],
    queryFn,
    {
      ...actualQueryOptions,
      staleTime: 60000,
    },
  );

  if (options?.handleErrors && query.status === 'error') {
    if (!query.isRefetchError) {
      throwFetchError(query.error);
    }
  }

  return query;
}
